import { Button, makeStyles, tokens } from '@fluentui/react-components';
import type { ReactNode } from 'react';
import { selectedControlIconStyles, selectedControlStyles } from './controlStyles';

const useStyles = makeStyles({
  button: {
    width: '100%',
    justifyContent: 'flex-start',
    gap: tokens.spacingHorizontalS,
    minHeight: '2.5rem',
    borderRadius: tokens.borderRadiusMedium,
    fontWeight: tokens.fontWeightRegular,
  },
  icon: {
    width: '1.5rem',
    height: '1.5rem',
    textAlign: 'center',
    color: tokens.colorNeutralForeground2,
    '& svg': {
      width: '1.5rem',
      height: '1.5rem',
    },
  },
  selectedIcon: {
    ...selectedControlIconStyles,
  },
});

export type SelectableTileProps = {
  icon?: ReactNode;
  label: string;
  selected: boolean;
  onSelect: () => void;
  disabled?: boolean;
};

export function SelectableTile({
  icon,
  label,
  selected,
  onSelect,
  disabled = false,
}: SelectableTileProps) {
  const styles = useStyles();
  return (
    <Button
      className={styles.button}
      style={selected ? selectedControlStyles : undefined}
      appearance="outline"
      aria-pressed={selected}
      disabled={disabled}
      onClick={onSelect}
    >
      {icon ? (
        <span className={`${styles.icon} ${selected ? styles.selectedIcon : ''}`}>{icon}</span>
      ) : null}
      {label}
    </Button>
  );
}
